import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { FormeGiuridiche } from "src/app/feature/user/model/user.model";
import { endpoints } from "src/environments/environment";

import { UserInfo } from "./model/fullInfo";
import { UrlUtilService } from "../url-util/url-util.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private USER_FULL = endpoints.user_full;
  private contact_profile = endpoints.contact_profile;
  private cities = endpoints.cities;
  private provinces = endpoints.provinces;
  private countries = endpoints.countries;
  private SAVE_PROFILE = endpoints.save_profile;
  private TITLES = endpoints.titles;
  private MY_PROFILE = endpoints.my_profile;
  private ASSOCIATION = endpoints.association;
  private userLogUrl = endpoints.user_log;
  private hasManutenzioneUrl = endpoints.has_manutenzione;
  private hasRequestDeliveryAppointmentUrl = endpoints.has_request_delivery_appointment;
  private retrieve_codice_gruppo = endpoints.retrieve_codice_gruppo;
  private exclusion_functionality_by_codice_gruppo = endpoints.exclusion_functionality_by_codice_gruppo;
  private CHECKEMAIL= endpoints.check_email_user;
  private UPDATE_LAST_LOGIN=endpoints.update_last_login;
  constructor(private http: HttpClient, private oauthService: OAuthService ){}


  hasManutenzione() {
    return this.http.get(this.hasManutenzioneUrl);
  }

  retrieveCodiceCapoGruppo(customerId) {
    return this.http.post(
      `${this.retrieve_codice_gruppo}?customerId=${customerId}`, {}
    );
  }

  exclusionFunctionality(codiceCapoGruppo) {
    return this.http.get(
      `${this.exclusion_functionality_by_codice_gruppo}/${codiceCapoGruppo}`
    );
  }

  hasRequestDeliveryAppointment(quotationTemplateId) {
    return this.http.get(
      `${this.hasRequestDeliveryAppointmentUrl}?quotationTemplateId=${quotationTemplateId}`
      );
  }

  userLog(userInfo: UserInfo) {
    return this.http.post(this.userLogUrl, userInfo);
  }
  getUserFullInfo() {
    return this.http.post(this.MY_PROFILE, {});
  }
  saveProfile(body) {
    return this.http.post(this.SAVE_PROFILE, body);
  }
  getFullInfo(isCacheToUse): Observable<any> {
    return this.http.get(`${this.USER_FULL}?isCacheToUse=${isCacheToUse}`);
  }

  getTitles() {
    return this.http.get(this.TITLES);
  }

  getCities(province: string): Observable<any> {
    return this.http
      .get(`${this.cities}?initial=${province}`)
      .pipe(map((res: any) => res.cities));
  }

  getProvinces() {
    return this.http.get(this.provinces).pipe(map((res: any) => res.provinces));
  }

  getCountries() {
    return this.http.get(this.countries).pipe(map((res: any) => res.countries));
  }

  formeGiuridiche() {
    return of(FormeGiuridiche);
  }

  public getContactProfileSync(): Promise<any> {
    return this.getContactProfile().toPromise();
  }

  getContactProfile() {
    return this.http.get(this.contact_profile);
  }

  setAssociation(associationCode) {
    return this.http.post(`${this.ASSOCIATION}/${associationCode}`, {});
  }

  updateLastLogin(contactId) {
    return this.http.post(`${this.UPDATE_LAST_LOGIN}/${contactId}`, {});
  }
}

interface driverEsito{
  esito:boolean
}